// @ts-check

/** @file Shared metadata helpers for HTML editor file attachments. */

/**
 * Formats attachment metadata for compact display.
 * @param {{contentType?: string | null, sizeBytes?: number | null}} args Values stored on the editor node.
 * @returns {string} Compact label text.
 */
export function attachmentMetadataText({contentType, sizeBytes}) {
  const parts = []

  if (contentType) parts.push(contentType)
  if (typeof sizeBytes === "number") parts.push(formatFileSize(sizeBytes))

  return parts.join(" - ")
}

/**
 * Formats bytes using browser-style binary units.
 * @param {number} sizeBytes Raw byte count from the editor node.
 * @returns {string} Compact byte count.
 */
export function formatFileSize(sizeBytes) {
  if (sizeBytes < 1024) return `${sizeBytes} B`

  const sizeKilobytes = sizeBytes / 1024

  if (sizeKilobytes < 1024) return `${sizeKilobytes.toFixed(1)} KB`

  return `${(sizeKilobytes / 1024).toFixed(1)} MB`
}

/**
 * Parses a file size from an HTML attribute.
 * @param {string | null | undefined} value Attribute value.
 * @returns {number | null} Parsed size.
 */
export function parseSizeBytes(value) {
  if (!value) return null

  const parsedSize = Number.parseInt(value, 10)

  if (!Number.isFinite(parsedSize) || parsedSize < 0) return null

  return parsedSize
}
